import { type ReactElement } from 'react';
import FeaturePageLayout from '../../components/features/FeaturePageLayout';

export default function Produkte(): ReactElement {
  return (
    <FeaturePageLayout
      badge="Buchhaltung"
      title="Produkte und Dienstleistungen verwalten"
      subtitle="Pflegen Sie Ihren Artikelstamm und Stundensätze. Fügen Sie sie mit einem Klick in Angebote und Rechnungen ein."
      heroImage="/screenshots/app-produkte.webp"
      heroImageAlt="Produkte und Leistungen in Saldify mit Preisen und Steuersätzen"
      features={[
        {
          title: 'Artikelstamm pflegen',
          description: 'Legen Sie Produkte mit Preis, Beschreibung und Steuersatz an. Einmal anlegen, immer wieder verwenden.',
        },
        {
          title: 'Stundensätze definieren',
          description: 'Hinterlegen Sie verschiedene Stundensätze für unterschiedliche Tätigkeiten oder Kunden.',
        },
        {
          title: 'Preislisten erstellen',
          description: 'Erstellen Sie kundenspezifische Preislisten mit Rabatten oder Sonderkonditionen.',
        },
        {
          title: 'Kategorien & Gruppen',
          description: 'Organisieren Sie Ihr Sortiment in Kategorien für schnelles Auffinden.',
        },
        {
          title: 'Bestandsführung',
          description: 'Verfolgen Sie Lagerbestände und erhalten Sie Warnungen bei niedrigem Bestand.',
        },
        {
          title: 'Einkaufspreise',
          description: 'Hinterlegen Sie Einkaufspreise für Margenberechnung und Gewinnanalyse.',
        },
      ]}
      sections={[
        {
          title: 'Blitzschnelle Rechnungserstellung',
          description: 'Fügen Sie gespeicherte Produkte und Dienstleistungen mit einem Klick in Ihre Rechnungen ein. Preis, Beschreibung und Steuersatz werden automatisch übernommen.',
          bullets: [
            'Produkte per Suche finden',
            'Menge anpassen',
            'Individuelle Rabatte möglich',
            'Automatische Preisberechnung',
          ],
          imageSide: 'right',
        },
        {
          title: 'Behalten Sie Ihre Margen im Blick',
          description: 'Mit hinterlegten Einkaufspreisen sehen Sie sofort, wie profitabel jedes Produkt und jeder Auftrag ist. Treffen Sie bessere Geschäftsentscheidungen.',
          bullets: [
            'Deckungsbeitrag pro Produkt',
            'Margenwarnung bei zu niedrigen Preisen',
            'Umsatz- und Gewinnstatistik',
            'Bestverkaufte Produkte identifizieren',
          ],
          imageSide: 'left',
        },
      ]}
      ctaTitle="Legen Sie Ihre ersten Produkte an"
      ctaDescription="Starten Sie mit Ihren meistverkauften Produkten und Dienstleistungen und beschleunigen Sie Ihre Rechnungserstellung."
    />
  );
}
